import { gql } from '@apollo/client';
import { FRAGMENT_SHORT_TEXT_FIELD, FRAGMENT_CONTENT_FIELD } from '$apollo/gql/cms/contentful';

export const MUTATION_RESET_PASSWORD = gql`
  mutation ResetPassword($resetPasswordInputs: ResetPasswordInputs!) {
    resetPassword(resetPasswordInputs: $resetPasswordInputs) {
      success
    }
  }
`;

export const GET_FORGOT_PASSWORD_CMS = gql`
  query GetForgotPasswordCMS($preview: Boolean, $locale: String!) {
    getForgotPasswordCMS: component(id: "1E6DbW0hTgHf8WdVP36dMT", locale: $locale, preview: $preview) {
      entriesCollection {
        items {
          ...ShortTextField
          ...ContentField
        }
      }
    }
  }

  ${FRAGMENT_SHORT_TEXT_FIELD}
  ${FRAGMENT_CONTENT_FIELD}
`;
